import { Controller } from "@hotwired/stimulus"
import { initializeGlide } from "@client/ui/initializeGlide"

export default class CarouselController extends Controller {
  static targets = ["carouselElement"]

  static values = {
    options: Object,
  }

  connect() {
    const carouselId = `carousel-${Math.random().toString(16).slice(2)}`

    this.carouselElementTarget.setAttribute("data-carousel-id", carouselId)
    this.carouselElementTarget.setAttribute(
      "data-carousel-tracker-carousel-id-value",
      carouselId,
    )

    const glide = initializeGlide(
      `[data-carousel-id="${carouselId}"]`,
      this.optionsValue,
    )

    this.carouselElementTarget.dataset.glideInstanceId = carouselId
    window.__glideInstances = window.__glideInstances || {}
    window.__glideInstances[carouselId] = glide
  }
}
